class VwPatolojiLaboratuvarDTO {
    id: number = 0;
    orderDetayId?: number = null;
    alinmaTarih?: string = null;
    dokuTemelOzellikId?: number = null;
    alinmaSekliId?: number = null;
    yerlesimYerId?: number = null;
    bulasiciVarMi?: string = "";
    acil?: string = "";
    talepAciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    materyalId?: number = null;
    materyalAdet?: number = null;
    klinikBilgi?: string = "";
    laboratuvarBilgi?: string = "";
    numunedurum?: number = null;
    fkTeslimedenpersonel?: number = null;
    muracaatId?: number = null;
    kimlikId?: number = null;
    hastaservisId?: number = null;
    organizasyonId?: number = null;
    servisId?: number = null;
    doktorId?: number = null;
    asistanId?: number = null;
    aciklama?: string = "";
    bagliOrganizasyonId?: number = null;
    doktorAdi?: string = "";
    servisAdi?: string = "";
    hastaAdiSoyadi?: string = "";
    yerlesimyeradi?: string = "";
    dokutemelozellikadi?: string = "";
    alinmasekiladi?: string = "";
    materyaladi?: string = "";
    rednedenadi?: string = "";
    teslimedenpersoneladsoyad?: string = "";
    teslimalanpersoneladsoyad?: string = "";
    hastaraporId?: number = null;
    protokolNo?: number = null;
    protokolOnek?: string = "";
    protokolYil?: number = null;
    protokolSira?: number = null;
    raportip?: number = null;
    orderId?: number = null;
    onaytarih?: string = null;
    raporTipTanimid?: number = null;
    kabultarihsaat?: string = null;
    orderPatolojiId?: number = null;
    organizasyonAdi?: string = "";
    kurumId?: number = null;
    hastaislemId?: number = null;
    islemadi?: string = "";
    morfolofiKodu?: string = "";
    islemtanimId?: number = null;
    biyopsiNo?: string = "";
    preperatdurumId?: number = 7;
    revizeedilenraporId?: number = null;
    revizetarih?: string = null;
    revizeno?: number = null;
    revizeaciklama?: string = "";
    revizekullaniciId?: number = null;
    gonderilecekOrganizasyonId?: number = null;
    protokolGosterim ?: string = "";
    babaAdi ?: string = "";
    rezervBarkodno?: number = null;
    icKurumBarkodNo?: string = "";


    //View dışı
    onayladaAktar?: string = "";
};
export default VwPatolojiLaboratuvarDTO;